<template>
  <div>
    <TeJobWebmarketingCover />

    <TeJobAbout>
      <template #title>
        Webマーケティング
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          Webマーケティングを中心とした学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #chatsupportText>
        19時〜23時の間のシフト制で、
      </template>
      <template #reviewText>
        カリキュラム内で出される課題のレビューしていただきます。<br class="hidden md:block">受講生が最適な出稿プランが作成できるまで繰り返し徹底したサポートを行い、挫折させることなく確実にスキルを上げる取り組みです。
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-masui.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Tatsumi Masui"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Tatsumi Masui
          </h4>
          <p>
            2001年からグルーバル企業の公式Webサイトの運用＆マーケティングの統括、2013年に独立してからは、グローバル企業のWeb戦略コンサルティング、Webマーケティングの運用代行などを行っています。
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-muraji.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Kumiko Muraji"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Kumiko Muraji
          </h4>
          <p>
            広告代理店を経て、メーカーEC運用部門にてサイト構築運用・カスタマーオペレーション・ロジスティクスと経験した後、ブランディング及び販促戦略企画に携わり、現在はWeb解析アナリストとして従事。「Googleアナリティクス公式コミュニティ」プロフェッショナルランキング回答者。
          </p>
        </div>
      </template>
    </TeJobMentor>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          Webマーケティングメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faChartLineUp"
                class="h-12 w-[3.25rem] text-[#5d478c]"
              />
            </template>
            <template #title>
              Webマーケティングの経験
            </template>
            <template #description>
              広告代理店経験者、企業のマーケティング経験者（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-analytics.png"
                alt="Google Analytics"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Google Analytics
            </template>
            <template #description>
              Googleアナリティクスの運用経験（1年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faList"
                class="h-12 w-[3.25rem] text-[#5cb85c]"
              />
            </template>
            <template #title>
              SEO/SEM
            </template>
            <template #description>
              SEO/SEMに関する知識と運用経験（1年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faChartColumn"
                class="h-12 w-[3.25rem] text-co-danger-500"
              />
            </template>
            <template #title>
              広告の出稿・運用
            </template>
            <template #description>
              ディスプレイ広告、Facebook広告、Twitter広告の運用経験（1年以上）
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="webmarketing" />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobWebmarketingCover from '~/components/Te/TeJob/Webmarketing/TeJobWebmarketingCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChartLineUp, faList, faChartColumn } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

useJobHead()

useHead({
  title: 'Webマーケティング講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするWebマーケティングメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'Webマーケティング講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするWebマーケティングメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '/_nuxt/ogp/og-image-mentor-webmarketing.jpg',
      ogTitle: 'Webマーケティング講師（メンター）募集',
      ogDescription:
        '受講生をサポートするWebマーケティングメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job/webmarketing',
      ogImage: '/_nuxt/ogp/og-image-mentor-webmarketing.jpg',
    }),
  ],
})
</script>
